import React, { useState, useEffect, useContext } from 'react'
import Table from "components/Table/Table";
import UserDetailsAPI from 'apis/userDetails/UserDetails';
import Context from 'context/context';
import searchIcon from "assets/img/Search_Icon.png";
import { styles } from './styles'
import { toast } from "react-toastify";
import { CSVLink } from 'react-csv';
import * as moment from "moment";
import useDebounce from "helpers/useDebounce";


import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import { MenuItem } from '@material-ui/core'

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { blockInvalidCharForText } from 'helpers/blockInvalidCharForText';

// custom TextField
const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "##D3D3D3",
        },
        "& .MuiFormLabel-root": {
            color: "#707070",
        },
        "& .MuiInputBase-input": {
            color: "#707070",
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#707070",
            },
            "&:hover fieldset": {
                borderColor: "#707070",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#707070",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: 20,
            },
            "&.MuiOutlinedInput-root": {
                marginTop: 0,
                borderRadius: 20,
                background: "#ededed",
            },
        },
    },
})(TextField);

const sendEmailTransition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function OnewebRestrictedShipto() {
    const { handleCanadaOnewebRestrictedShipto } = UserDetailsAPI()
    const { state, dispatch } = useContext(Context)
    const classes = styles();
    const [data, setData] = useState([])
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true)
    const [searchValue, setSearchValue] = useState("")
    const [createObj, setCreateObj] = useState({
        customer_account_number: '',
        is_active: '',
        type: 'CREATE'
    });
    const [editObj, setEditObj] = useState({
        customer_account_number: '',
        is_active: '',
        type: 'UPDATE'
    });
    const [popupOpen, setPopupOpen] = useState(false);
    const searchBounceValues = useDebounce(searchValue);

    useEffect(() => {
        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch()
        } else {
            getUserDetails()
        }
    }, [searchBounceValues, offset])

    async function getUserDetails() {
        try {
            setLoading(true)
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
                type: "GET"
            };

            dispatch({ type: "SET_LOADING", payload: true });
            let res = await handleCanadaOnewebRestrictedShipto(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
            }
        } catch (e) {
            console.log({ e });
        }
    }

    async function handleSearch() {
        try {
            setLoading(true)
            let values;
            values = {
                searchValue,
                offset: (offset - 1) * 10,
                limit: 10,
                type: "SEARCH"
            };

            dispatch({ type: "SET_LOADING", payload: true });
            let res = await handleCanadaOnewebRestrictedShipto(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
            }
        } catch (e) {
            console.log({ e });
        }
    }

    async function handleCreate() {
        try {
            const { customer_account_number, is_active } = createObj;
            if (!customer_account_number || !is_active) {
                return toast.error('Please fill all the fields');
            }
            setLoading(true);
            dispatch({ type: "SET_LOADING", payload: true });
            let res = await handleCanadaOnewebRestrictedShipto(createObj);
            if (res.type == 'success') {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.success(res.message)
                setPopupOpen(false)
                getUserDetails();
            } else {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.error(res.message)
            }
        } catch (e) {
            console.log({ e });
        }
    }

    async function handleUpdate() {
        try {
            setLoading(true);
            dispatch({ type: "SET_LOADING", payload: true });
            let res = await handleCanadaOnewebRestrictedShipto(editObj);
            if (res.type == 'success') {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.success(res.message)
                setEditObj({})
            } else {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.error(res.message)
            }
        } catch (e) {
            console.log({ e });
        }
    }


    let tableHeading = [
        "id",
        "Shipto ID",
        "Status",
        ""
    ];

    const handlePagination = (value) => {
        setOffset(value);
    };

    return (
        <div>
            <h2>Oneweb Restricted Shipto</h2>
            <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
                <Grid>
                    <CssTextField
                        id="enterPassword"
                        placeholder={'Search for Shipto'}
                        onKeyDown={blockInvalidCharForText}
                        type={"text"}
                        variant="outlined"
                        autoComplete="off"
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setSearchValue("");
                                                setOffset(1);
                                                getUserDetails();
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=""
                                            width="20px"
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            ),
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            e.target.value.replace(/\s+/g, "").length == 0
                                ? setSearchValue("")
                                : setSearchValue(e.target.value);
                            if (e.target.value.length == 0) {
                                getUserDetails();
                            }
                        }}
                        onClick={() => {
                            setOffset(1);
                        }}
                    />
                    <Button
                        className={`${classes.createBtn} dash-1-filter-btn`}
                        onClick={() => {
                            setPopupOpen(true)
                        }}
                    >
                        {'Create'}
                    </Button>
                </Grid>
            </Grid>
            <div style={{ marginTop: 20 }}>
                {!loading ? <Table
                    headings={tableHeading.map((i) => {
                        return <div key={i}>{i}</div>
                    })}
                    data={data &&
                        data.length > 0 &&
                        data.map((p) => [
                            [p?.id],
                            [p?.customer_account_number],
                            editObj?.customer_account_number == p?.customer_account_number ?
                                <TextField
                                    select
                                    value={editObj?.is_active}
                                    onChange={e => setEditObj({ ...editObj, is_active: e.target.value })}
                                    style={{ width: "100%" }}
                                >
                                    <MenuItem value={true}>Active</MenuItem>
                                    <MenuItem value={false}>In-Active</MenuItem>
                                </TextField> :
                                [p?.is_active == true ?
                                    <span style={{ color: "green" }}>Active</span> :
                                    <span style={{ color: "red" }}>In-Active</span>
                                ],
                            [
                                <Button
                                    className={`${classes.createBtn} dash-1-filter-btn`}
                                    onClick={() => {
                                        setEditObj({ ...editObj, customer_account_number: p?.customer_account_number, is_active: p?.is_active })
                                    }}
                                >
                                    {'Edit'}
                                </Button>,
                                [editObj.customer_account_number == p?.customer_account_number && <Button
                                    className={`${classes.createBtn} dash-1-filter-btn`}
                                    onClick={handleUpdate}
                                >
                                    {'Save'}
                                </Button>],
                                [editObj.customer_account_number == p?.customer_account_number && <Button
                                    className={`${classes.createBtn} dash-1-filter-btn`}
                                    onClick={() => setEditObj({})}
                                >
                                    {'Cancel'}
                                </Button>]
                            ]
                        ])}
                    offset={offset}
                    count={
                        (count / 10) % 1 == 0
                            ? Math.floor(count / 10)
                            : Math.floor(count / 10 + 1)
                    }
                    handlePagination={handlePagination}
                /> :
                    <div style={{ height: '25vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h2>Loading...</h2>
                    </div>}
            </div>
            <Dialog
                open={popupOpen == true}
                TransitionComponent={sendEmailTransition}
                keepMounted
                onClose={() => setPopupOpen(false)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <span
                            style={{ float: "right", color: "red", cursor: "pointer" }}
                            onClick={() => {
                                setPopupOpen(false);
                            }}
                        >
                            X
                        </span>
                    </DialogContentText>
                    <TextField
                        id="guid"
                        placeholder={'Enter Shipto'}
                        type={"text"}
                        style={{ margin: 10, width: '90%' }}
                        variant="outlined"
                        autoComplete="off"
                        value={createObj?.customer_account_number}
                        onChange={(e) => {
                            setCreateObj({ ...createObj, customer_account_number: e.target.value })
                        }}
                    />
                    <TextField
                        id="type"
                        placeholder={'Status'}
                        select
                        style={{ margin: 10, width: '90%' }}
                        variant="outlined"
                        autoComplete="off"
                        value={createObj.is_active}
                        onChange={(e) => {
                            setCreateObj({ ...createObj, is_active: e.target.value })
                        }}
                    >
                        <MenuItem value={true}>Active</MenuItem>
                        <MenuItem value={false}>In-Active</MenuItem>
                    </TextField>
                    <Button
                        className={`${classes.createBtn} dash-1-filter-btn`}
                        style={{ width: 120, marginLeft: '40%' }}
                        onClick={handleCreate}
                    >
                        {'Create'}
                    </Button>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default OnewebRestrictedShipto;